import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionButton from "components/common/ActionButton";
import IconButton from "components/common/IconButton";
import AdvanceTablePagination from "components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";
import { deleteCompany, deleteUser, getUsers, deleteCompanyByMasterId } from "functions/user";
import { deleteClient } from 'functions/client';

import { useEffect, useState, useContext } from "react";
import { Button, Card, Col, Dropdown, FormControl, InputGroup, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AllTicketsHeader from "./AllTicketsHeader";
import { useBreakpoints } from "hooks/useBreakpoints";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import DeleteConfirm from "components/dialogBoxes/DeleteConfirm";
import { toast } from "react-toastify";
import MessageBox from "components/dialogBoxes/MessageBox";
import { getClients } from "functions/client";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import AppContext from 'context/Context';

const TableHeader = ({
    selectedRowIds,
    globalFilter,
    setGlobalFilter,
    layout,
    handleShow,
    selectedItems,
    handleTicketsSearch,
    users
  }) => {
    const navigate = useNavigate();

    const handleExportToExcel = () => {
      // Prepare data for Excel
      const exportData = users.map(user => ({
        "Company Name": user.companyName,
        "Customer Code": user.customerCode,
        "Company Address": user.companyAddress,
        "Company Tel": user.companyTel
      }));

      // Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");

      // Download the Excel file
      XLSX.writeFile(workbook, "Clients_List.xlsx");
    };
  
  
    return (
      <div className="d-lg-flex justify-content-between">
        <Row className="flex-between-center gy-2 px-x1">
          <Col xs="auto" className="pe-0">
            <h6 className="mb-0" style={{ color: textColor }}>All clients</h6>
          </Col>
          <Col xs="auto">
            {layout === 'table-view' ? (
              <AdvanceTableSearchBox
                className="input-search-width"
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                placeholder="Search by name"
              />
            ) : (
              <InputGroup className="position-relative input-search-width">
                <FormControl
                  size="sm"
                  id="search"
                  type="search"
                  className="shadow-none"
                  placeholder="Search by name"
                  onChange={e => handleTicketsSearch(e.target.value)}
                />
                <Button
                  size="sm"
                  variant="outline-secondary"
                  className="border-300 hover-border-secondary"
                >
                  <FontAwesomeIcon icon="search" className="fs--1" />
                </Button>
              </InputGroup>
            )}
          </Col>
        </Row>
        <div className="border-bottom border-200 my-3"></div>
        <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
          <IconButton
            variant="falcon-default"
            size="sm"
            icon="filter"
            transform="shrink-4"
            iconAlign="middle"
            onClick={handleShow}
            className="d-xl-none"
          >
            <span className="d-none d-sm-inline-block ms-1">Filter</span>
          </IconButton>
          <div
            className="bg-300 mx-3 d-none d-lg-block d-xl-none"
            style={{ width: '1px', height: '29px' }}
          ></div>
          {(selectedRowIds && Object.keys(selectedRowIds).length > 0) ||
          (selectedItems && selectedItems.length > 0) ? (
            <div className="d-flex">
              <Form.Select size="sm" aria-label="Bulk actions">
                <option>Bulk Actions</option>
                <option value="refund">Refund</option>
                <option value="delete">Delete</option>
                <option value="archive">Archive</option>
              </Form.Select>
              <Button
                type="button"
                variant="falcon-default"
                size="sm"
                className="ms-2"
              >
                Apply
              </Button>
            </div>
          ) : (
            <div id="orders-actions">
              <IconButton
                variant="success"
                size="sm"
                icon="plus"
                transform="shrink-3"
                iconAlign="middle"
                onClick={()=>{
                  navigate('/support-desk/new-ticket');
                }}
              >
                <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
                  New Ticket
                </span>
              </IconButton>
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="external-link-alt"
                transform="shrink-3"
                className="mx-2"
                iconAlign="middle"
                onClick={() => console.log('Export button clicked')} // Add onClick handler

              >
                <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
                  Exports
                </span>
              </IconButton>
              <Dropdown align="end" className="btn-reveal-trigger d-inline-block">
                <Dropdown.Toggle split variant="falcon-default" size="sm">
                  <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
                </Dropdown.Toggle>
  
                <Dropdown.Menu className="border py-0">
                  <div className="py-2">
                    <Dropdown.Item>View</Dropdown.Item>
                    <Dropdown.Item>Export</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item className="text-danger">Remove</Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
      </div>
    );
  };



const ListClients=()=>{
    const { config } = useContext(AppContext);
    const { isDark } = config;
    const textColor = isDark ? '#fff' : '#212529';
    const tableBg = isDark ? undefined : '#fff';

    const [users,setUsers]=useState([]);
    const [isTicketLoading, setIsTicketLoading] = useState(false);

    const [userData,setUserData]=useState(null);

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [userIdToDelete, setUserIdToDelete] = useState(null);
    const [message, setMessage] = useState(null);

    useEffect(()=>{
      const _userData=JSON.parse(localStorage.getItem('userData'));
      setUserData(_userData);
    console.log('userData',_userData);
    
    },[])
   

    const loadClients = async () => {
      try {
  
        const token=localStorage.getItem('token');
    
        setIsTicketLoading(true);
   
       const res = await getClients(token);
       console.log('loadClients recordset ', res)
  
        const usersArr = [];
  
        res &&
        res.map(r => {
  
            usersArr.push({
              id: r.CompanyMasterId,
              customerCode:r.CustomerCode,
              companyName:r.CompanyName,
              companyAddress:r.CompanyAddress,
              companyTel:r.CompanyTel,
             companyMasterId:r.CompanyMasterId,
             isActive: r.ActiveStatus, // Add isActive field
            });
          });
          setIsTicketLoading(false);
  
          setUsers(usersArr);
      } catch (err) {
        console.log('Error', err);
      }
    };
  

    const navigate = useNavigate();
  
    useEffect(() => {
      loadClients();
     },[]);
   

const columns = [
  {
    accessor: 'companyName',
    Header: 'Company Name',
    headerProps: { style: { minWidth: '4.625rem' ,color: textColor} },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { companyName,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{companyName}</p>
      );
    }
  },
  {
    accessor: 'customerCode',
    Header: 'Customer Code',
    headerProps: { style: { minWidth: '4.625rem',color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { customerCode,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{customerCode}</p>
      );
    }
  },
  {
    accessor: 'companyAddress',
    Header: 'Company Address',
    headerProps: { style: { minWidth: '4.625rem',color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { companyAddress,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{companyAddress}</p>
      );
    }
  },
  {
    accessor: 'companyTel',
    Header: 'Company Tel.',
    headerProps: { style: { minWidth: '4.625rem',color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { companyTel,id } = rowData.row.original;
      return (
        <p style={{ color: textColor }}>{companyTel}</p>
      );
    }
  },
  {
    accessor: 'isActive',
    Header: 'Active',
    headerProps: { style: { minWidth: '4.625rem',color: textColor } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { isActive } = rowData.row.original;
      return (
        <span style={{ color: isActive ? 'green' : 'red', fontWeight: 'bold' }}>
          {isActive ? 'Active' : 'Inactive'}
        </span>
      );
    }
  },
  {
    accessor: 'companyMasterId',
    Header: 'Action',
    headerProps: { style: { minWidth: '4.625rem' ,color: textColor} },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { companyMasterId,id } = rowData.row.original;
      return (
        <>
             
        <ActionButton icon="edit" title="Edit" variant="action" className="p-0 me-2" onClick={() => {
    navigate(`/support-desk/add-client/${id}/U`, { state: rowData.row.original });
  }} />
        <ActionButton icon="trash-alt" title="Delete" variant="action" className="p-0" onClick={() => handleShowDialogDelete(id, companyMasterId)} />
        </>
      );
    }
  },

];

const TableView = () => {
  const [show, setShow] = useState(false);
  const { breakpoints } = useBreakpoints();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  
   //const [tickets,setTickets]=useState([]);

   const [skip,setSkip]=useState(null);
   const [limit,setLimit]=useState(null);
   const [isTicketLoading, setIsTicketLoading] = useState(false);



  return (
    <>
      <AdvanceTableWrapper
  columns={columns}
  data={users}
  selection
  selectionColumnWidth={52}
  sortable
  pagination
  perPage={11}
  rowCount={users.length}
>
  <Card>
    <Card.Header className="border-bottom border-200 px-0" style={{ color: textColor, background: tableBg }}>
      <AllTicketsHeader
        table
        layout="table-view"
        handleShow={handleShow}
        exportClientsToExcel={() => exportClientsToExcel(users)}
      />
    </Card.Header>
    <Card.Body className="p-0" style={{ background: tableBg }}>
    {isTicketLoading ? (
      <div className="p-5 d-flex align-items-center justify-content-center" style={{ color: textColor }}>
<ItemsLoading1
      animation="border"
      size="sm"
      message="Loading please wait..."
    />

</div>
) : ( <AdvanceTable
        table
        headerClassName="bg-light text-800 align-middle"
        rowClassName="btn-reveal-trigger align-middle"
        tableProps={{
          size: 'sm',
          className: 'fs--1 mb-0 overflow-hidden',
          style: { color: textColor, background: tableBg },
          children: [
            <style key="table-white-text">{`
              .table thead th, .table th {
                color: ${isDark ? '#fff' : '#212529'} !important;
                background: ${isDark ? '#23272b' : '#f8f9fa'} !important;
              }
              .table tbody td, .table tfoot td, .table td {
                color: ${isDark ? '#fff' : '#212529'} !important;
              }
            `}</style>
          ]
        }}
      />
      )}
    </Card.Body>
    <Card.Footer style={{ color: textColor, background: tableBg }}>
   
      <AdvanceTablePagination table />
    </Card.Footer>
  </Card>


</AdvanceTableWrapper>

    </>
  );
};




const handleShowDialogDelete = (id) => {
  setUserIdToDelete(id);
  setShowDeleteConfirm(true);
};

const handleConfirmDelete = async () => {
  setShowDeleteConfirm(false);
  console.log(token);
const token = localStorage.getItem('token');
    const userLogId = localStorage.getItem('userData');
    const userId = userLogId ? JSON.parse(userLogId).userId : null;
    const gmtOffset = userLogId ? JSON.parse(userLogId).gmtOffset : null;

  // Use the new API for deleting company by master id
    const res = await deleteClient(userIdToDelete, token, gmtOffset, userLogId);
  console.log('Full deleteCompanyByMasterId response:', res);

  // Safely check for res.data before accessing
  if (res && res.data && res.status === 400) {
    setMessage({ title: 'Exception', message: res.data.error, variant: 'danger' });
  } else if (res && res.status === 400) {
    setMessage({ title: 'Exception', message: 'Unknown error occurred', variant: 'danger' });
  }

  setUserIdToDelete(null);
  loadClients();
};

const handleCancelDelete = () => {
  setShowDeleteConfirm(false);
  setUserIdToDelete(null);
  console.log('Cancelled!');
};

const onMessageBoxCloseHandler=()=>{
  setMessage(null);
}

const exportClientsToExcel = (clients) => {
  if (!Array.isArray(clients) || clients.length === 0) {
    alert('No clients to export!');
    return;
  }
  const data = clients.map(client => ({
    "Company Name": client.companyName,
    "Customer Code": client.customerCode,
    "Company Address": client.companyAddress,
    "Company Tel": client.companyTel,
    "Active status": client.isActive
  }));
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Set column widths for more space between columns
  worksheet['!cols'] = [
    { wch: 25 }, // Company Name
    { wch: 18 }, // Customer Code
    { wch: 40 }, // Company Address
    { wch: 18 }, // Company Tel
    { wch: 18 }  // Company Te
  ];

  // Optionally, make header row bold (works in some SheetJS builds)
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cell_address = XLSX.utils.encode_cell({ r: 0, c: C });
    if (!worksheet[cell_address]) continue;
    worksheet[cell_address].s = { font: { bold: true } };
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', cellStyles: true });
  const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(file, 'clients.xlsx');
};


return (
  <>
    <Row className="gx-3">
      <Col xxl={12} xl={12}>
        <TableView exportClientsToExcel={() => exportClientsToExcel(users)} />
        {showDeleteConfirm &&  <DeleteConfirm
          title="Confirm Delete"
          message="Do you want to confirm?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />}
        {message && <MessageBox onMessageBoxClose={onMessageBoxCloseHandler} title={message.title} message={message.message} variant={message.variant} />}
      </Col>
    </Row>
  </>
);

}

export default ListClients;